module.exports = __webpack_public_path__ + "img/home_bg1_d@2x.93a1e33f.png";